'use client';
import React from 'react';
import Link from 'next/link';
import { CheckCircle, ArrowRight } from 'lucide-react';

const features = [
  'Unlimited call answering (24/7)',
  'Real-time transcription & summaries',
  'Caller sentiment analysis',
  'Automated SMS follow-ups (Twilio)',
  'Custom AI knowledge base',
  'Command Center dashboard',
  'Call analytics & reports',
  'Multi-language support (configurable via VAPI)',
  'Priority email support',
];

const addons = [
  { label: 'Additional phone numbers', price: '$YOUR_PRICE/mo' },
  { label: 'Outbound call campaigns', price: '$YOUR_PRICE/mo' },
  { label: 'CRM integrations (Zoho, Freshdesk)', price: '$YOUR_PRICE/mo' },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="py-20 lg:py-28">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            One plan. Everything included.{' '}
            <span className="text-gradient">No surprises.</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Set your own pricing and currency before launch.
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="relative card-elevated p-8 border-primary/40 glow-primary">
            <div className="text-center mb-8">
              <div className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-2">
                VoiceLink AI — All Inclusive
              </div>
              <div className="flex items-baseline justify-center gap-2 mb-1">
                <span className="text-5xl font-extrabold text-foreground tabular-nums">
                  $YOUR_PRICE
                </span>
                <span className="text-muted-foreground font-medium">/month</span>
              </div>
              <div className="text-sm text-muted-foreground">
                + tax where applicable • Billing provider connected by the buyer
              </div>
              {/* TODO: Connect Stripe or Paddle checkout and billing portal here. */}
              <div className="mt-2 text-xs text-positive font-medium">
                {/* TODO: set your price and currency for the final product */}
                Replace this placeholder with your published plan pricing.
              </div>
            </div>

            {/* Features list */}
            <div className="space-y-3 mb-8">
              {features?.map((feat) => (
                <div key={`price-feat-${feat?.slice(0, 20)}`} className="flex items-start gap-3">
                  <CheckCircle size={16} className="text-positive flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-foreground">{feat}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Link
              href="/sign-up-login-screen"
              className="btn-primary w-full justify-center text-base py-3.5 mb-4"
            >
              Start 14-Day Free Trial
              <ArrowRight size={18} />
            </Link>
            <p className="text-center text-xs text-muted-foreground">
              No credit card required for trial • Cancel anytime • Buyer chooses billing provider
            </p>
          </div>

          {/* Add-ons */}
          <div className="mt-6 card-elevated p-5">
            <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">
              Optional Add-ons
            </div>
            <div className="space-y-2">
              {addons?.map((addon) => (
                <div key={`addon-${addon?.label?.slice(0, 15)}`} className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">{addon?.label}</span>
                  <span className="font-semibold text-foreground tabular-nums">{addon?.price}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
